import { CurrencyPipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  constructor(private currencyPipe: CurrencyPipe) {}

  formatCurrencyEvent(event: any, currencyCode: string) {
    const originalValue = ('' + event.target.value).trim();

    // Determine sign (allow leading '-')
    const isNegative = originalValue.startsWith('-');

    // Remove non-digit characters from the input value (keep only digits)
    let digits = originalValue.replace(/[^\d]/g, '');

    // Ensure at least 0
    if (digits.length === 0) {
      digits = '0';
    }

    // Build decimal string from minor units
    let numericStr: string;
    if (digits.length === 1) {
      numericStr = '0.0' + digits;
    } else if (digits.length === 2) {
      numericStr = '0.' + digits;
    } else {
      numericStr = digits.slice(0, -2) + '.' + digits.slice(-2);
    }

    if (isNegative && Number(numericStr) !== 0) {
      numericStr = '-' + numericStr;
    }

    // Format using Angular CurrencyPipe
    const formatted = this.currencyPipe.transform(numericStr, currencyCode, 'symbol-narrow', '1.2-2');

    // Set the formatted value back to the input field
    event.target.value = formatted;

    // Return minor units string with sign preserved
    const penceDigits = digits.replace(/^0+/, '') || '0';
    const penceValue = (isNegative && penceDigits !== '0') ? ('-' + penceDigits) : penceDigits;
    return penceValue;
  }

  formatCurrency(amount: any, currencyCode: string) {
    const originalValue = ('' + amount).trim();
    const isNegative = originalValue.startsWith('-');

    // Keep only digits
    let digits = originalValue.replace(/[^\d]/g, '');
    if (digits.length === 0) {
      digits = '0';
    }

    // Build decimal string from minor units
    let numericStr: string;
    if (digits.length === 1) {
      numericStr = '0.0' + digits;
    } else if (digits.length === 2) {
      numericStr = '0.' + digits;
    } else {
      numericStr = digits.slice(0, -2) + '.' + digits.slice(-2);
    }

    if (isNegative && Number(numericStr) !== 0) {
      numericStr = '-' + numericStr;
    }

    return this.currencyPipe.transform(numericStr, currencyCode, 'symbol-narrow', '1.2-2');
  }


}
